/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { blankComponent } from './layout/layouts/blank.component';
import { LoginComponent } from './pages/admin/auth/login.component';
import { LogoutComponent } from './pages/admin/auth/logout.component';
import { ZaloRedirectComponent } from './pages/admin/icontact/setting/conversation/zalo/login_redirector/zalo.component';
import { IContactRoute } from './pages/admin/icontact/icontact.route';

@NgModule({
  imports: [
    RouterModule.forRoot([
      ...IContactRoute,
      {
        path: '',
        component: blankComponent,
        children: [
          { path: 'login', component: LoginComponent },
          { path: 'logout', component: LogoutComponent },
          { path: 'zalo-redirect', component: ZaloRedirectComponent },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AppAdminRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-admin.routes.ts